import routes from 'actions/routes';
import { generateReadActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    read: generateReadActionCreator(routes.API_ACCOUNT_OPTIONS, ACTION_NAMES.ACCOUNT_OPTIONS)
};
